export const MOBILE_NAV_HEIGHT = 52;
export const DESKTOP_NAV_HEIGHT = 70;
export const DESKTOP_NAV_CHILD_HEIGHT = 38;
export const MOBILE_CONTROLS_WIDTH = 180;
export const DESKTOP_CONTROLS_WIDTH = 140;
